// 外部から投稿されたデータを表示する(詳細画面)。
// FIXME:現在未着手(2025/4/14)
/*-------------------
    モジュールのimport
---------------------*/
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

/*-------------------
    cssのimport
---------------------*/
import '../css/public.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet-gesture-handling';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';
/*-------------------
    画像のimport
---------------------*/
import imgMapg from '../images/icon/ico-maps.svg';

/*-------------------
    classのimport
---------------------*/
import * as commons from '../commons';
import Footer from '../components/Footer';

// クラス名
class PublicList extends Component {
  constructor(props) {
    super(props);

    // URLを取得。
    const url = props.location.pathname;
    // 市町村を取得する。
    const num = url.lastIndexOf('/');
    const lgCrypt = url.slice(num + 1);

    this.state = { lgCrypt };
  }

  componentDidMount = async () => {
    const { lgCrypt } = this.state;
    const { lgCd, permission } = await commons.getLgCd(lgCrypt);
    if (lgCd === '' || permission < 7) {
      commons.moveErrorPage(this.props, '10');
      return;
    }

    // 設定系統を取得する。
    const promise = [];

    // 市町村設定を取得
    promise.push(commons.commonSetting({ lgCd, colName: 'M_LCL_SETTING', objName: 'lclSetting' }));

    // 全てのプロミスが完了した後に行う処理。
    const results = await Promise.all(promise);
    const resultList = commons.changePromiseRes(results);

    const { lclSetting } = resultList;
    const resSetting = this.getSetting(lclSetting);
    const resDetail = await this.getDetail();

    this.setState({ ...resSetting, ...resDetail });
  };

  /**
   * 設定情報を取得する。
   * @memberof PublicList
   */
  getSetting = (lclSetting) => {
    // 地方公共団体の情報を取得
    if (lclSetting.length === 0) {
      commons.moveErrorPage(this.props, '10');
      return '';
    }

    const { public_map: publicMap = '' } = lclSetting[0] || '';
    const { title = '' } = publicMap;

    if (title === '') {
      commons.moveErrorPage(this.props, '30');
      return '';
    }

    document.title = title; // タブのタイトルを設定する。

    // URLから中心座標を取得する。
    const { location } = this.props;
    const { search = '' } = location;
    const urlSearch = search;

    return { formTitle: title, urlSearch };
  };

  /**
   * 設定情報を取得する。
   * @memberof PublicList
   */
  getDetail = async () => {
    const { location } = this.props;
    const urlQuery = new URLSearchParams(location.search);
    const mastaId = urlQuery.get('id') || '';
    const kind = urlQuery.get('kind') || '';

    let resData = '';
    if (kind === 'haven') {
      resData = await commons.getMarker({ mastaId, colName: 'M_HAVEN', idName: 'haven_id' });
    }

    console.log(resData);
  };

  /**
   * 画面遷移
   * @memberof PublicList
   */
  onClickBtnMove = () => {
    const { history } = this.props;
    const { urlSearch = '', lgCrypt } = this.state;
    history.push({ pathname: `../map/${lgCrypt}`, search: urlSearch });
  };

  /**
   * テスト用
   *
   * @memberof PublicList
   */
  test = () => {
    console.log('test');
  };

  render() {
    const { lgCrypt, formTitle } = this.state;

    return (
      <div>
        <div className="head-sticky">
          <div className="pb_list_title">
            <div>{formTitle}</div>
            <div style={{ fontWeight: '100' }}>
              <img src={imgMapg} alt="地図アイコン" className="icon" />
              <button
                type="button"
                className="btnAtag"
                onClick={() => this.onClickBtnMove(`../map/${lgCrypt}`)}
              >
                地図表示
              </button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

PublicList.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default withRouter(PublicList);
